import { Box, Button, Text, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { AppContainer, useAppContainer, useContentMeta } from 'src/UI/app-container';

export default function SuitabilityReportEditPage() {
  const { id } = useParams<{ id: string }>();
  const { mode, toggleMode, isExpanded } = useAppContainer();

  useContentMeta({
    pageType: 'suitability-report-edit',
    entityId: id,
  });

  return (
    <>
      <Box>
        <Title order={2}>Edit Suitability Report</Title>
        <Text c="dimmed" mt="md">
          Report ID: {id}
        </Text>
        <Text mt="lg">This page uses the new AppContainer layout.</Text>
        <Text mt="sm">
          Context pane mode: <strong>{mode}</strong> ({isExpanded ? 'expanded' : 'standard'})
        </Text>
        <Button mt="md" onClick={toggleMode}>
          Toggle Context Pane Size
        </Button>
      </Box>

      <AppContainer.SidebarContent>
        <Box>
          <Title order={4} c="white">
            Sidebar
          </Title>
          <Text c="white" mt="sm">
            Custom sidebar content for this page.
          </Text>
        </Box>
      </AppContainer.SidebarContent>
    </>
  );
}
